import { Link } from "react-router-dom";
import { Globe, Mail, FileSignature, FolderKanban, LifeBuoy, Calculator, RefreshCw } from "lucide-react";
import { useApi } from "@/hooks/useApi";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Section, Loading } from "@/components/common/ui-bits";

const Stat = ({ to, icon: Icon, label, value, testid }) => (
  <Link to={to} className="card-box fade-up flex items-center gap-4 p-5 transition-[transform,box-shadow] duration-150 hover:-translate-y-0.5 hover:shadow-md" data-testid={testid}>
    <span className="rounded-md bg-blue-50 p-2.5 text-blue-700"><Icon className="h-5 w-5" /></span>
    <span><span className="num block text-2xl font-semibold text-slate-900">{value ?? "—"}</span><span className="text-xs text-slate-500">{label}</span></span>
  </Link>
);

export default function PortalHome() {
  const { user } = useAuth();
  const { data: client } = useApi(`/clients/${user.client_id}`);
  const { data: proposals } = useApi("/proposals");
  const { data: projects } = useApi("/projects");
  const { data: support } = useApi("/support", { open_only: true });
  const { data: taxes } = useApi("/tax-cases");
  const { data: renewals } = useApi("/renewals");
  if (!client) return <Loading />;
  const d = client.digital || {};
  const pending = (proposals || []).filter((p) => ["Enviada", "Vista por el cliente", "Cambios solicitados"].includes(p.status)).length;

  return (
    <div>
      <PageHeader title={`Hola, ${client.contact_name || client.trade_name || client.legal_name}`} subtitle={client.trade_name || client.legal_name} />
      <div className="mb-6 grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
        <Stat to="/portal/propuestas" icon={FileSignature} label="Propuestas por responder" value={pending} testid="portal-stat-proposals" />
        <Stat to="/portal/proyectos" icon={FolderKanban} label="Proyectos" value={projects?.length} testid="portal-stat-projects" />
        <Stat to="/portal/taxes" icon={Calculator} label="Casos de taxes" value={taxes?.length} testid="portal-stat-taxes" />
        <Stat to="/portal/solicitudes" icon={LifeBuoy} label="Solicitudes abiertas" value={support?.length} testid="portal-stat-support" />
        <Stat to="/portal/renovaciones" icon={RefreshCw} label="Renovaciones por aprobar" value={renewals?.filter((r) => r.status === "Pendiente de aprobación").length} testid="portal-stat-renewals" />
      </div>
      <div className="grid gap-6 lg:grid-cols-2">
        <Section title="Su página web" testid="portal-website">
          <p className="flex items-center gap-2 text-sm"><Globe className="h-4 w-4 text-slate-400" />
            {d.website_url ? <a href={d.website_url} target="_blank" rel="noreferrer" className="break-all text-blue-700 hover:underline">{d.website_url}</a> : "[PENDIENTE]"}</p>
          {d.domain && <p className="mt-2 text-xs text-slate-500">Dominio: {d.domain}</p>}
        </Section>
        <Section title="Correo asignado" testid="portal-emails">
          {(d.email_accounts || []).length ? d.email_accounts.map((e) => <p key={e} className="flex items-center gap-2 text-sm"><Mail className="h-4 w-4 text-slate-400" />{e}</p>)
            : <p className="text-sm text-slate-500">[PENDIENTE]</p>}
          <p className="mt-3 text-xs text-slate-400">Por seguridad, las contraseñas nunca se muestran en el portal.</p>
        </Section>
      </div>
    </div>
  );
}
